module.exports = __webpack_public_path__ + "static/financial-forecast-ee3736b32352a2b518f0aba5d98285c2.png";